export function initScrollAnimations() {
  const targets = Array.from(document.querySelectorAll('[data-animate]'));
  if (!targets.length) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion) {
    for (const el of targets) el.classList.add('is-visible');
    return;
  }

  // Stagger index for children inside [data-animate-stagger] containers
  const staggerContainers = Array.from(document.querySelectorAll('[data-animate-stagger]'));
  for (const container of staggerContainers) {
    const children = Array.from(container.querySelectorAll(':scope > [data-animate]'));
    children.forEach((child, index) => {
      child.style.setProperty('--stagger-index', String(index));
    });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;

        const el = entry.target;
        const delay = Number(el.getAttribute('data-delay') || '0');
        if (delay) el.style.transitionDelay = `${delay}ms`;

        el.classList.add('is-visible');
        observer.unobserve(el);
      }
    },
    { root: null, threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
  );

  for (const el of targets) observer.observe(el);
}
